import { render, staticRenderFns } from "./ApplyCert.vue?vue&type=template&id=590f7301"
import script from "./ApplyCert.vue?vue&type=script&lang=js"
export * from "./ApplyCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports